import api from '../lib/axios'

/**
 * Utilise la même instance axios que AdminOrders (token, baseURL, intercepteurs).
 * Retourne le body JSON et lève une Error avec le vrai message Laravel,
 * pour rester compatible avec les composants existants (res.data, res.stats, err.message).
 */
async function request(path, { method = 'GET', body, params } = {}) {
  try {
    const res = await api.request({ url: path, method, data: body, params })
    return res.data
  } catch (e) {
    const d = e?.response?.data
    const firstError = d?.errors && Object.values(d.errors).flat()[0]
    throw new Error(firstError || d?.message || e?.message || 'Erreur API')
  }
}

// Client
export const getPlans               = () => request('/plans')
export const getCurrentSubscription = () => request('/subscription/current')
export const cancelSubscription     = () => request('/subscription/cancel', { method: 'POST' })
export const resumeSubscription     = () => request('/subscription/resume', { method: 'POST' })

// Admin — subscriptions
export const getAdminSubscriptions = (params = {}) =>
  request('/admin/subscriptions', { params })

export const getAdminUserDetail      = (userId) => request(`/admin/subscriptions/${userId}`)
export const createAdminSubscription = (payload) =>
  request('/admin/subscriptions', { method: 'POST', body: payload })
export const updateAdminSubscription = (id, payload) =>
  request(`/admin/subscriptions/${id}`, { method: 'PUT', body: payload })
export const deleteAdminSubscription = (id) =>
  request(`/admin/subscriptions/${id}`, { method: 'DELETE' })
export const extendAdminSubscription = (id, days) =>
  request(`/admin/subscriptions/${id}/extend`, { method: 'POST', body: { days } })
export const cancelAdminSubscription = (id) =>
  request(`/admin/subscriptions/${id}/cancel`, { method: 'POST' })

// Admin — clients (users)
export const createAdminClient = (payload) =>
  request('/admin/clients', { method: 'POST', body: payload })
export const updateAdminClient = (id, payload) =>
  request(`/admin/clients/${id}`, { method: 'PUT', body: payload })
export const deleteAdminClient = (id) =>
  request(`/admin/clients/${id}`, { method: 'DELETE' })
// Admin — pages des clients
export const getClientPages = (userId) =>
  request(`/admin/clients/${userId}/pages`)

export const updateClientPage = (pageId, payload) =>
  request(`/admin/pages/${pageId}`, {
    method: 'PUT',
    body: payload,
  })

// Admin — suspend / activate client
export const setClientActive = (userId, active) =>
  request(
    `/admin/users/${userId}/${active ? 'activate' : 'suspend'}`,
    { method: 'POST' }
  )
  
// Admin — assign / unassign pages
export const getAssignablePages = () =>
  request('/admin/pages/assignable')

export const assignPageToClient = (userId, pageId) =>
  request(`/admin/clients/${userId}/pages/${pageId}/assign`, {
    method: 'POST',
  })

export const unassignPage = (pageId) =>
  request(`/admin/pages/${pageId}/unassign`, {
    method: 'POST',
  })
